import React, { useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import UserContext from '../../../config/UserContext'
import {
  HttpService,
  API,
  swal,
  Title,
  toast,
  Messages,
  DateFormat,
  Spinner,
  ExportToExcel
} from '../../../config/react'
import DataTable from 'react-data-table-component'

const Users = () => {
  const [UsersList, setUsersList] = useState([])
  const user = useContext(UserContext)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [totalRows, settotalRows] = useState()
  const [IsAuth, setIsAuth] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [loading, setLoading] = useState(true)
  const [SearchTerm, setSearchTerm] = useState('')
  const columns = [
    {
      name: 'Username',
      selector: (row) => row.name,
      sortable: true,
      sortField: 'Name'
    },
    {
      name: 'Email',
      selector: (row) => row.email,
      sortField: 'Email',
      sortable: true
    },
    {
      name: 'Role',
      selector: (row) => (row.roles !== undefined ? row.roles : ''),
      sortable: false,
      wrap: true
    },
    {
      name: 'Status',
      selector: (row) => (row.is_active === 1 ? <label>Active</label> : <label>Inactive</label>)
    },
    {
      name: 'Created Date',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>,
      sortField: 'created_at',
      sortable: true
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={'/users/edit/' + row.id}
            className="text-dark"
            title="Edit"
          >
            <i
              className="fa fa-pencil-square-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
          {user.id !== row.id && (
            <Link
              onClick={(e) => DeleteUser(e, row.id)}
              to=""
              className="text-dark"
              title="Delete"
            >
              <i
                className="fa fa-trash-o"
                aria-hidden="true"
              ></i>{' '}
            </Link>
          )}
        </div>
      )
    }
  ]

  const DefaultFilters = {
    page: 1,
    // search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)

  useEffect(() => {
    setIsAuth(true)
    document.title = Title.Users
    GetUsersList()
  }, [CustomFilters, SearchTerm])
  const GetUsersList = () => {
    const param = {
      _id: 0,
      _page: CustomFilters.page,
      _search: SearchTerm,
      _page_size: CustomFilters.page_size,
      _sort_column: CustomFilters.sort_column,
      _sort_direction: CustomFilters.sort_direction
    }
    setLoading(true)
    HttpService.postApi(API.GetUsers, param).then((response) => {
      setLoading(false)
      if (response.data.status) {
        const data = response.data.result[1]
        setUsersList(data)
        if (response.data.result[0].length > 0) settotalRows(response.data.result[0][0].total)
        setForceUpdate(!isForceUpdate)
      }
    })
  }
  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page_size: e, page: 1 })
  }

  const handleSort = (e, direction) => {
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Name, Email."
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) =>
          setTimeout(() => {
            setSearchTerm(e.target.value)
          }, 1000)
        }
      />
    )
  })

  const DeleteUser = async (e, id) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          _id: id
        }
        setLoading(true)
        HttpService.postApi(API.DeleteUser, param).then((response) => {
          setLoading(false)
          toast.success(Messages.RecordDeleted)
          GetUsersList()
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }
  const handleExportExcel = () => {
    HttpService.postApi(API.GetUserExcel).then((response) => {
      if (response.data.result) {
        ExportToExcel(response.data.result[0], 'Users')
      }
    })
  }

  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.Users} </h3>
        <div className="btn-group">
          <Link
            to="/users/add"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            Add User{' '}
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <button
                className="btn btn-primary float-right m-1"
                onClick={handleExportExcel}
              >
                Export Excel
              </button>
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={UsersList}
                  pagination
                  paginationServer
                  persistTableHead={true}
                  progressPending={loading}
                  progressComponent={<Spinner />}
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeaderComponent={subHeaderComponentMemo}
                  paginationDefaultPage={currentPage}
                  subHeader
                  onSort={handleSort}
                  sortServer
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Users
